import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentListItemMoveFailedAction = {
	type: 'DOCUMENT_LIST_ITEM_MOVE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentListItemMoveFailedAction => ({
	type: 'DOCUMENT_LIST_ITEM_MOVE_FAILED',
	payload,
});
